import { requestHandler } from '../../api';

export const getAutocompleteGlobalSearcher = async (
  dispatch: any,
  requesData: any,
) => {
  const { label, input } = requesData;
  const response = await requestHandler({
    method: 'post',
    url: `internal/search/globalSearcher/autocomplete`,
    data: { label, input },
    headers: {},
    dispatch,
  });
  if (response) return response.data;
};
